export default __webpack_public_path__ + "static/media/SeaLife_05.73e31327.png";